import React from 'react'
import { UseFormReturn } from 'react-hook-form'
import { IClient } from 'src/app/shared/models/clientSetup.model'
import { ViewAccountFormValues } from '../models'

export enum AccountStatus {
  New = 'new',
  Active = 'active',
  ARCHIVE = 'archive',
  UNARCHIVE = 'unarchive',
}

export interface ViewAccountContextProps {
  loading: boolean
  form: UseFormReturn<ViewAccountFormValues>
  checkExceptionProcessingType: string
  achExceptionProcessingType: string
  isFetched: boolean
  client: IClient | null
}

export const ViewAccountContext = React.createContext<ViewAccountContextProps>({
  loading: false,
  form: null as any,
  isFetched: false,
  checkExceptionProcessingType: '',
  achExceptionProcessingType: '',
  client: null,
})

export const useViewAccountContext = () => React.useContext<ViewAccountContextProps>(ViewAccountContext)
